import React from 'react';
import { useTranslation } from 'react-i18next';
import TitleField from '../../../fields/TitleField';
import DescriptionField from '../../../fields/DescriptionField';
import GallerySelectField from '../../../fields/GallerySelectField';
import GroupSelectField from '../../../fields/GroupSelectField';
import LabelsField from '../../../fields/LabelsField';
import LicenseField from '../../../fields/LicenseField';
import LegalDocumentsField from '../../../fields/LegalDocumentsField';
import DisableCommentsField from '../../../fields/DisableCommentsField';
import ScrapsToggleField from '../../../fields/ScrapsToggleField';
import NotifyWatchersField from '../../../fields/NotifyWatchersField';
import SellFieldsGroup from '../../../fields/SellFieldsGroup';
import FieldsGroup from '../../common/FieldsGroup';
import HorizontalSeparator from '../../common/HorizontalSeparator';
import LiteraturePreview from '../../common/LiteraturePreview';
import TagsField from '../../../fields/TagsField';
import RecommendedTagsField from '../../../fields/RecommendedTagsField';
import LabelOptionsForm from '../../../common/LabelOptionsForm';
import DesktopSubmitLayout from '../DesktopSubmitLayout';

import s from './LiteratureSubmitForm.scss';

interface Props {}

const LiteratureSubmitForm: React.FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <DesktopSubmitLayout
      preview={<LiteraturePreview />}
      previewClassName={s['preview']}
    >
      <TitleField />
      <LabelOptionsForm />
      <TagsField />
      <RecommendedTagsField withBottomMargin />
      <DescriptionField />
      <GallerySelectField />
      <GroupSelectField />

      <HorizontalSeparator margins="both" />
      <SellFieldsGroup />

      <HorizontalSeparator margins="both" />
      <FieldsGroup
        title={t('deviationSubmit.form.section.advanced.title')}
        isCollapsible
      >
        <LabelsField />
        <LicenseField />
        <LegalDocumentsField />
        <DisableCommentsField />
        <ScrapsToggleField />
        <NotifyWatchersField />
      </FieldsGroup>
    </DesktopSubmitLayout>
  );
};
LiteratureSubmitForm.displayName = 'LiteratureSubmitForm';

export default LiteratureSubmitForm;
